<template>
  <button
    class="productAsideReviews"
    :style="{width: '100%'}"
    @click.prevent="handleScroll()"
    :aria-label="`Click to read all ${onText}`"
    :title="`Click to read all ${onText}`"
  >
    <div v-if="rating === 4">
      <Star4/>
      <p>{{ onText }}</p></div>
    <div v-if="rating === 4.5">
      <Star4half/>
      <p>{{ onText }}</p></div>
    <div v-if="rating === 5">
      <Star5/>
      <p>{{ onText }}</p>
    </div>
  </button>
</template>

<script>
import Star4 from "./stars/Star4.vue";
import Star4half from "./stars/Star4half.vue";
import Star5 from "./stars/Star5.vue";

export default {
  name: "reviews",
  components:{
    Star4,
    Star4half,
    Star5,
  },
  props: {
    count:{
      type: Number,
      default: 0
    },
    rating:{
      default: 0
    }
  },
  methods: {
    handleScroll() {
      const element = document.getElementById('product-trustpilot');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  },
  computed: {
    onText(){
      return `${this.count} reviews`
    }
  }
}
</script>
